import React from "react";
import Box from "../Box";
import { CLoader, CText } from "@carrefour/design-system-components-react";
import styled from "styled-components";

type LoadingProps = {
  message: string;
};
const Text = styled(CText)`
  font-family: system-ui;
`;
const LoadingPage = ({ message }: LoadingProps) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100vh"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        mb={8}
        style={{ gap: "8px" }}
      >
        <CLoader data-testid={"loader"} />
        <Text size={"l"} style={{ fontFamily: "system-ui" }}>
          {message}
        </Text>
      </Box>
    </Box>
  );
};

export default LoadingPage;
